import { useEffect, useState, useRef } from "react";
import { GpsFixed, supportAgent, Verified } from "assets/images";
import Drawer from "react-modern-drawer";
import {
  useChatIndexQuery,
  useLazyGeoLocationLiveQuery,
  useReadAllMessageMutation,
  useTrackerIndexQuery,
} from "redux/RTQ/IlenkradApi";

import getUserLocale from "pagesPc/utils/getUserLocale";
import LoadingLottiePc from "components/lottieLoading/LoadingLottiePc";
import ChatPc from "./ChatPc";
import { useNavigate } from "react-router-dom";
import TrackerAlertModals from "components/v2/Modals/TrackerAlertModals/TrackerAlertModals";
import { useSelector } from "react-redux";

const NotificationPc = ({ closeDrawer }: any) => {
  const drawerState = useSelector((state: any) => state.drawer);
  const [dataFilterChat, setDataFilterChat] = useState<any>([]);
  const changeFilterName = (e: string) => {
    const chats = dataChat?.chats || [];
    const filter = chats.filter((msg: any) => msg.title?.includes(e));
    setDataFilterChat(filter);
  };
  const [chatId, setChatId] = useState<any>();
  const [isPaymentModalOpen, setIsPaymentModalOpen] = useState<boolean>(false);
  const [currentTracker, setCurrentTracker] = useState<any>({});
  const [isExpiredTrackersModalOpen, setIsExpiredTrackersModalOpen] =
    useState<boolean>(false);
  const [currentTrackers, setCurrentTrackers] = useState<any>([]);
  const prevChatDrawerStateRef = useRef<boolean>(false);

  // Listen to Redux state for chat drawer trigger
  useEffect(() => {
    // Only open if transitioning from false to true (opening), not from true to false (closing)
    if (
      drawerState.isChatDrawerOpen &&
      !prevChatDrawerStateRef.current &&
      drawerState.selectedChatId
    ) {
      setChatId(drawerState.selectedChatId);
      setTimeout(() => {
        setIsOpen(true);
      }, 1000);
    }
    prevChatDrawerStateRef.current = drawerState.isChatDrawerOpen;
  }, [drawerState.isChatDrawerOpen, drawerState.selectedChatId]);

  const locale = getUserLocale();
  const dateOptions: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  };
  const {
    data: dataChat,
    isLoading: isLoadingChat,
    isSuccess: isSuccessChat,
    error: errChat,
  } = useChatIndexQuery(undefined, {
    pollingInterval: 10000, // poll every 10s to update new_messages count
    refetchOnFocus: true,
    refetchOnReconnect: true,
  });
  useEffect(() => {
    const dataSuccess: any = dataChat?.chats;
    if (isSuccessChat) {
      setDataFilterChat(dataSuccess);
    }
  }, [errChat, isSuccessChat, dataChat]);
  const [mutateReadAll, { isLoading: isLoadingReadAll }] =
    useReadAllMessageMutation();
  const [mutateLocationLive, { data: dataLocationLive }] =
    useLazyGeoLocationLiveQuery();
  const { data: dataAllTracker } = useTrackerIndexQuery();
  useEffect(() => {
    mutateLocationLive();
  }, []);
  const navigate = useNavigate();
  const openPaymentModal = (currentTracker: any) => {
    setCurrentTracker(currentTracker);
    setIsPaymentModalOpen(true);
  };

  const closePaymentModal = () => {
    setIsPaymentModalOpen(false);
    closeDrawer();
  };

  const openExpiredTrackersModal = (currentTrackers: any) => {
    setCurrentTrackers(currentTrackers);
    setIsExpiredTrackersModalOpen(true);
  };

  const closeExpiredTrackersModal = () => {
    setIsExpiredTrackersModalOpen(false);
    closeDrawer();
  };

  const navigateToPlans = () => {
    navigate("/plans");
    closeDrawer();
  };

  const submitReadAll = () => {
    if (!dataLocationLive?.geo_locations) {
      mutateReadAll("");
      return;
    }
    if (
      Object.values(dataLocationLive.geo_locations).some(
        (live: any) => live?.expired === true,
      )
    ) {
      const liveLocations = dataLocationLive.geo_locations as Record<
        string,
        any
      >;
      const expiredDevicesImeis = Object.values(liveLocations)
        .filter((live) => live?.expired)
        .map((live) => live?.imei?.toString());

      openExpiredTrackersModal(
        (dataAllTracker?.trackers || []).filter((tracker: any) =>
          expiredDevicesImeis.includes(tracker.imei),
        ),
      );
    } else {
      mutateReadAll("");
    }
  };

  const [isOpen, setIsOpen] = useState<boolean>(false);
  const closeDrawerChat = () => {
    setIsOpen(false);
    closeDrawer();
  };
  if (isLoadingChat || isLoadingReadAll) {
    return <LoadingLottiePc />;
  }
  return (
    <>
      <Drawer
        open={isOpen}
        direction="left"
        size={400}
        overlayOpacity={0.7}
        zIndex={99999}
      >
        {isOpen ? <ChatPc closeDrawer={closeDrawerChat} id={chatId} /> : null}
      </Drawer>
      <div className="containerBgNotificationPc">
        <div className="rowCloseDrawerNotification">
          <div onClick={closeDrawer} className="icon3-close pointer" />
        </div>
        <div className="headerListTracker">
          <div className="itemRightNotification">
            <input
              onChange={(e) => changeFilterName(e.target.value)}
              placeholder="در بین دستگاه ها جستجو کنید"
              className="inpFilterNotificationPc"
              type="text"
              name="filter"
            />
            <div className="icon6-search inputSearchIcon" />
          </div>
        </div>
        <div onClick={submitReadAll} className="readAllNotification pointer">
          <div className="icon5-mark_chat_read" />
          <div className="textReadAllNotification">خواندن همه</div>
        </div>
        <div className="contentListTracker scrollbar-div">
          {dataFilterChat.map((item: any) => (
            <div
              onClick={() => {
                if (
                  dataLocationLive?.geo_locations[item.tracker_imei]?.expired
                ) {
                  openPaymentModal(
                    dataAllTracker.trackers.filter(
                      (tracker: any) => tracker.imei === item.tracker_imei,
                    )[0],
                  );
                } else {
                  setChatId(item?.id);
                  setTimeout(() => {
                    setIsOpen(true);
                  }, 1000);
                }
              }}
              key={item?.id}
              className="notificationListItem pointer"
            >
              <div className="notificationItemRight">
                <div className="notificationListItemRight">
                  <img
                    src={
                      item.title.includes("پشتیبانی")
                        ? supportAgent
                        : item.title.includes("ردیاب")
                          ? GpsFixed
                          : Verified
                    }
                    alt={item.title || "chat icon"}
                    className={"notificationListImg"}
                  />
                  {item?.new_messages > 0 ? (
                    <div className="countMessagesChat">
                      {item?.new_messages}
                    </div>
                  ) : null}
                </div>
                <div className="notifItemHeader">{item?.title}</div>
              </div>
              <div className="notificationListItemMiddle">
                <div className="notificationListItemLeftPc">
                  {new Date(item.updated_at).toLocaleTimeString(
                    locale,
                    dateOptions,
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <TrackerAlertModals
        trackers={currentTrackers}
        isPaymentModalOpen={isExpiredTrackersModalOpen}
        closePaymentModal={closeExpiredTrackersModal}
        onActionOne={navigateToPlans}
      />
      <TrackerAlertModals
        tracker={currentTracker}
        isPaymentModalOpen={isPaymentModalOpen}
        closePaymentModal={closePaymentModal}
        onActionOne={navigateToPlans}
      />
    </>
  );
};
export default NotificationPc;
